<template>
  <PageWrapper ref="pageEl" :title="title">
    <div class="container">
      <insurance-editor v-model="form" :logo-url="logoUrl"></insurance-editor>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import { uploadPublicImage } from "@/god"
import InsuranceEditor from "../components/InsuranceEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    InsuranceEditor,
  },
  data() {
    const title = "สร้างประกัน"
    const form = {
      label: "",
      description: "",
      url: "",
      logoFile: null,
    }

    const logoUrl = null
    return {
      title,
      form,
      logoUrl,
    }
  },
  watch: {
    form(form, oldForm) {
      if (this.form.logoFile === oldForm.logoFile) {
        return
      }

      this.logoUrl = URL.createObjectURL(this.form.logoFile)
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {},
    setupData() {},
    async handleClickSave() {
      try {
        await this.createInsurance()
        this.$router.push({ name: "InsuranceListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async createInsurance() {
      const { label, description, url, logoFile } = this.form
      const iconUrl = await uploadPublicImage(logoFile)

      const params = {
        title: label,
        subtitle: description,
        web_url: url,
        icon_url: iconUrl,
      }

      const response = await baanRueJaiClient.admin.insurances.post(params)

      return response.data.result
    },
  },
}
</script>

<style lang="scss" scoped></style>
